<template>
  <div class="nearby-hotels">
    <div class="container">
      <div class="nearby-hotels__expander row" @click="expanded = !expanded">
        {{ translate('rdNearbyHotels') }}
        <i v-if="expanded" class="icon icon-arrow-up xxs align-baseline ml-2"></i>
        <i v-if="!expanded" class="icon icon-arrow-down xxs align-baseline ml-2"></i>
      </div>
      <Slider
        v-if="hotels.length > 1 || isDesktop()"
        selector=".nearby-hotels__hotels"
        :slides-to-show="isDesktop() ? 2 : 1"
        :slides-to-scroll="1"
      >
        <div class="nearby-hotels__hotels row" v-show="expanded">
          <div class="nearby-hotels__hotel col" v-for="(hotel, index) in hotels" :key="index">
            <NearbyHotelCardComponent
              :hotel="hotel"
              :nearByHotelsExpanded="expanded"
              @checkAvailability="$emit('checkAvailability', $event)"
            />
          </div>
        </div>
      </Slider>
      <div v-else v-show="expanded">
        <NearbyHotelCardComponent
          :hotel="hotels[0]"
          :nearByHotelsExpanded="expanded"
          @checkAvailability="$emit('checkAvailability', $event)"
        />
      </div>
      <HotelGalleryModal
        v-for="(hotel, index) in filteredHotels"
        :key="index"
        :hotel="hotel.jsonHotel()"
      />
    </div>
  </div>
</template>

<script>
import NearbyHotelCardComponent from './NearbyHotelCardComponent'
import Slider from '../Slider'
import HotelGalleryModal from '../modal/HotelGalleryModal'

export default {
  name: 'NearbyHotelsComponent',
  components: { Slider, NearbyHotelCardComponent, HotelGalleryModal },
  props: {
    hotels: {
      type: Array
    },
    showExpandedByDefault: {
      type: Boolean,
      defaultValue: false
    }
  },
  computed: {
    filteredHotels() {
      return this.hotels.filter(hotel => hotel.hasGallery())
    }
  },
  watch: {
    showExpandedByDefault: function (newValue) {
      this.expanded = newValue
    }
  },
  data: () => ({
    expanded: false
  }),
  created() {
    this.expanded = this.showExpandedByDefault
  },
  methods: {
    onToggle() {
      this.expanded = !this.expanded
    },
    isDesktop() {
      return window.screen.width > 992
    }
  }
}
</script>

<style lang="scss" scoped>
.nearby-hotels {
  margin-top: 4rem;
  width: 100%;
  padding-left: 3rem;
  padding-right: 3rem;

  &__expander {
    cursor: pointer;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    margin-bottom: 3rem;
    font-size: 1.8rem;
  }

  @media (max-width: 991px) {
    padding-left: 0;
    padding-right: 0;

    &__hotel {
      padding: 0px;
      margin: 0px 0.5rem;
    }
  }
}
</style>
